export default "__VITE_ASSET__tJY6Rc6v__"